import type { AuthState } from 'types';

export enum STORE_KEYS {
  loginCode = 'loginCode',
  AUTH = 'auth',
  STAY_LOGGED_IN = 'stayLoggedIn',
  POST_LOGIN_REDIRECT = 'postLoginRedirect',
  IS_IMPERSONATING = 'isImpersonating',
  IS_SUBSTITUTING = 'isSubstituting',
}

export type PostLoginRedirect = {
  path: string;
  createdAt: number;
};

export type STORE_VALUES = {
  [STORE_KEYS.loginCode]: string;
  [STORE_KEYS.AUTH]: AuthState;
  [STORE_KEYS.STAY_LOGGED_IN]: boolean;
  [STORE_KEYS.POST_LOGIN_REDIRECT]: PostLoginRedirect;
  [STORE_KEYS.IS_IMPERSONATING]: boolean;
  [STORE_KEYS.IS_SUBSTITUTING]: boolean;
};
